import React, { useState, useEffect, useMemo } from "react";
import ReportBlock from "./ReportBlock";
import { reportsProducerData } from "../../utils/apis";
import { URLs } from "../../utils/apis";
import { Box, Flex, Text, useMantineTheme } from "@mantine/core";
import { useStylesPage } from "../../utils/mantine/useStylesPage";
import { useStylesReports } from "../../utils/mantine/useStylesReports";
import { useStylesTable } from "../../utils/mantine/useStylesTable";
import CustomAnchor from "../mantineCustomComponents/CustomAnchor";
import { useTableIcons } from "../../utils/collectionFound/iconsUtil";
import {
  reportsProducerTableColumns,
  reportsProducerTableData,
  reportsProducerTableOptions,
} from "../../utils/reports/reportsProducerTable";
import { MantineReactTable, useMantineReactTable } from "mantine-react-table";

const ProducerContent = () => {
  const theme = useMantineTheme();

  //css classes
  const { classes: classesPage } = useStylesPage();

  const { classes: reportsClasses } = useStylesReports();

  const { classes: tableClasses } = useStylesTable();

  // Initial state for input values
  const [inputValues, setInputValues] = useState({
    strategies: [],
    current_page: 1,
    total_pages: 1,
    producer_identity: {
      name: "",
      verified_by: "",
    },
    press_release: false,
    validation_information: {
      total_strategies: "",
      total_commits: "",
    },
  });

  useEffect(() => {
    reportsProducerData(1, setInputValues);
  }, []);

  // Icons used within the tables, provided through a custom utility function
  const faIcons = useMemo(() => useTableIcons(), []);

  const dataReportsProducer = useMemo(
    () => reportsProducerTableData(inputValues["strategies"]),
    [inputValues["strategies"]],
  );

  // Column definitions for the main table using a utility function
  const columnsReportsProducer = reportsProducerTableColumns();

  // Configuration options for the main table using Mantine's table library
  const tableReportsProducer = useMantineReactTable(
    reportsProducerTableOptions(
      columnsReportsProducer,
      dataReportsProducer,
      faIcons,
      theme,
    ),
  );

  return (
    <Box className={reportsClasses.reports}>
      <Box className={`${classesPage.header} ${reportsClasses.reportsHeader}`}>
        <Text
          className={`${classesPage.headerTitle} ${reportsClasses.reportsTitle}`}
        >
          Strategy Producer Profile
        </Text>
        <Text
          className={`${classesPage.headerText} ${classesPage.headerTextNoHeight} ${reportsClasses.reportsText}`}
        >
          The vBase app verifiably secures data, creating a timestamped record
          of your data’s existence. Build your credibility. Anyone with whom you
          share your file can validate its timestamp and integrity by checking
          the blockchain fingerprint.
        </Text>
      </Box>
      <Box className={reportsClasses.reportsBlock}>
        <Flex
          className={reportsClasses.reportsBlockInner}
          justify={theme.flex.justify.between}
          wrap="wrap"
        >
          <Box>
            <Box className={reportsClasses.reportsBlockTitle}>
              Producer Information
            </Box>

            <Box className={reportsClasses.reportsBlockItem}>
              <Box className={reportsClasses.reportsBlockKey}>
                Strategy Producer Identity:
              </Box>
              <Box component="b" className={reportsClasses.reportsBlockValue}>
                {inputValues.producer_identity?.name}
              </Box>
              {inputValues.producer_identity?.verified_by && (
                <>(Verified by {inputValues.producer_identity?.verified_by})</>
              )}
            </Box>
          </Box>
          <Box>
            <Flex
              gap={theme.flex.gap.base}
              className={reportsClasses.reportsBlockWrap}
            >
              {inputValues?.validation_information?.total_strategies && (
                <ReportBlock
                  background={theme.customBackgrounds.reportsBlock2}
                  color={theme.customColors.black}
                  title="Total Strategies"
                  number={inputValues?.validation_information?.total_strategies}
                  text="Total Strategies Total Strategies Total Strategies Total Strategies Total Strategies"
                />
              )}
              {inputValues?.validation_information?.total_commits && (
                <ReportBlock
                  background={theme.customBackgrounds.reportsBlock3}
                  color={theme.customColors.white}
                  title="Total Commits"
                  number={inputValues?.validation_information?.total_commits}
                  text="Total Commits Total Commits Total Commits Total Commits Total Commits "
                />
              )}
            </Flex>
            <Box
              className={`${reportsClasses.reportsAvailableDownload} ${reportsClasses.reportsAvailableDownloadProducer}`}
            >
              <Box className={reportsClasses.reportsAvailableDownloadTitle}>
                Press Release:{" "}
                {inputValues?.press_release ? (
                  <CustomAnchor text="Yes" href="#" componentClasses="link" />
                ) : (
                  <>No</>
                )}
              </Box>
            </Box>
          </Box>
        </Flex>
        <Flex
          justify={theme.flex.justify.between}
          className={reportsClasses.reportsTableTitleWrap}
        >
          <Box className={reportsClasses.reportsTableTitle}>Strategies</Box>
        </Flex>
        <Box className={tableClasses.table}>
          <MantineReactTable
            columns={reportsProducerTableColumns()}
            data={reportsProducerTableData}
            mb={theme.margin.mdSpacious}
            table={tableReportsProducer}
          />
        </Box>
      </Box>
      <Box mt={theme.margin.mdSpacious}>
        <CustomAnchor
          text="Back"
          componentClasses="buttonBlack anchor"
          href={URLs.REPORTS_PAGE_URL}
          IconChevronLeftEnable={true}
        ></CustomAnchor>
      </Box>
    </Box>
  );
};

export default ProducerContent;
